import dayjs from 'dayjs';
import { MyFleetAcidListItem } from './types';

export function parseMyFleetFile(text: string) {
    const lines = text.split('\n');

    const items: MyFleetAcidListItem[] = [];
    for (const line of lines) {
        const cols = line.split(',');
        if (cols.length < 1) {
            continue;
        }

        const acid = cols[0]?.trim();
        if (!acid) {
            continue;
        }

        const item: MyFleetAcidListItem = {
            acid: acid,
            scratchpad: cols[1]?.trim() || null,
            origin: cols[2]?.trim() || null,
            depDate: null,
            depHour: null
        };

        const date = cols[3];
        if (date && date.length === 8) {
            const yyyy = +date.slice(0, 4);
            const mm = +date.slice(4, 6);
            const dd = +date.slice(6, 8);
            if (Number.isFinite(yyyy) && Number.isFinite(mm) && Number.isFinite(dd)) {
                item.depDate = dayjs(new Date(yyyy, mm - 1, dd, 0, 0, 0, 0))
                    .utcOffset(0, true)
                    .unix();
            }
        }

        const hour = +cols[4];
        if (Number.isFinite(hour)) {
            item.depHour = hour === 24 ? null : hour;
        }

        items.push(item);
    }
    return items;
}
